const validateWorkletsVersion = () => {
	return {
		ok: true,
	};
};

export default validateWorkletsVersion;
